"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTriggerText = void 0;
var _TriggerText = require("./TriggerText");
// TODO: in v9, move styled() from TriggerText.jsx to here
var StyledTriggerText = _TriggerText.TriggerText;
exports.StyledTriggerText = StyledTriggerText;